import { useState } from 'react';
import { Page, PageHeader } from '../components/Page';
import { PCard } from '../components/PCard';
import { useAuth } from '../lib/auth';
import { reconcileHyperswitch, ApiError } from '../lib/api';

export const WebhooksPage = () => {
  const { can } = useAuth();
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  async function reconcile() {
    setBusy(true);
    setMsg(null);
    try {
      const r = await reconcileHyperswitch();
      setMsg(`Scanned ${r.scanned} new event(s), reconciled ${r.reconciled}${r.failed ? `, ${r.failed} failed` : ''}.`);
    } catch (e) {
      setMsg(e instanceof ApiError ? e.message : 'Reconcile failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Page>
      <PageHeader title="Payment events" sub="How inbound payment status reaches billing" />

      {msg && (
        <div style={{ padding: '8px 12px', borderRadius: 6, background: 'rgba(16,185,129,.08)', color: 'var(--status-success-ink,#047857)', fontSize: 13 }}>
          {msg}
        </div>
      )}

      <PCard style={{ padding: 16 }}>
        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>Stripe — platform fees</div>
        <div className="muted" style={{ fontSize: 13 }}>
          Push webhooks to <span className="mono">/api/webhooks/stripe</span> (verified with the server's Stripe webhook signing secret).
          Register that endpoint in the Stripe dashboard for <span className="mono">payment_intent.*</span> and <span className="mono">setup_intent.succeeded</span>.
        </div>
      </PCard>

      <PCard style={{ padding: 16, display: 'flex', gap: 12, alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>Hyperswitch — pharmacy &amp; shipping</div>
          <div className="muted" style={{ fontSize: 13 }}>
            We share the <span className="mono">greenstone_rx</span> merchant, whose single webhook goes to bloom.
            So we <strong>pull</strong> — a cron reads our events (tagged <span className="mono">metadata.system=5axis-billing</span>) from
            bloom&rsquo;s store and reconciles invoices. Off-session charges also reconcile synchronously.
          </div>
        </div>
        {can('payments:manage') && (
          <button className="btn btn--primary" onClick={reconcile} disabled={busy} style={{ whiteSpace: 'nowrap' }}>
            {busy ? 'Reconciling…' : 'Reconcile now'}
          </button>
        )}
      </PCard>
    </Page>
  );
};
